// extracted by mini-css-extract-plugin
module.exports = {"frame":"styles_frame__2r9QW","enter-from-end":"styles_enter-from-end__2ZzT6","enter-from-start":"styles_enter-from-start__3FiGw"};